import i18next from "i18next";
import { getOsIcon, OsEnum } from "../utils";
import { IFilterItemV2 } from "#src/commonV2/Table/Filter/types";

const fixedTFunc = i18next.getFixedT(null, "endpoint", "policies.table.filter");

export const operatingSystemFilterItems: IFilterItemV2[] = [
  {
    key: "apple",
    getLabel: () => fixedTFunc("operatingSystem.apple"),
    value: OsEnum.APPLE,
    leftIcon: getOsIcon(OsEnum.APPLE, 1.25),
  },
  {
    key: "windows",
    getLabel: () => fixedTFunc("operatingSystem.windows"),
    value: OsEnum.WINDOWS,
    leftIcon: getOsIcon(OsEnum.WINDOWS, 1.25),
  },
  {
    key: "ubuntu",
    getLabel: () => fixedTFunc("operatingSystem.ubuntu"),
    value: OsEnum.UBUNTU,
    leftIcon: getOsIcon(OsEnum.UBUNTU, 1.25),
  },
  {
    key: "android",
    getLabel: () => fixedTFunc("operatingSystem.android"),
    value: OsEnum.ANDROID,
    leftIcon: getOsIcon(OsEnum.ANDROID, 1.25),
  },
];

export const policyStatusFilterItems: IFilterItemV2[] = [
  {
    key: "enabled",
    getLabel: () => fixedTFunc("policyStatus.enabled"),
    value: "1",
  },
  {
    key: "disabled",
    getLabel: () => fixedTFunc("policyStatus.disabled"),
    value: "0",
  },
];
